import { defineComponent as _defineComponent } from 'vue'
import { V2Device } from 'ctp-search-device';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceBloc',
  props: {
  device: {
    type: Object,
    default: () => ({} as V2Device)
  }
},
  setup(__props) {

const props = __props;




return { __sfc: true,props }
}

})